/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@resurs/midas-react'
import Page from '../../../internal/Page'
import { getText } from '../../../internal/TextLabels'
import PaymentLogEntry from './UI/PaymentLogEntry'
import TransactionLogEntry from './UI/TransactionLogEntry'
import { TransactionTypes } from '../../../util/transactionConstants'
import { ChannelType } from '../../../models/channelType'

const TransactionHistory = ({ details, transaction }) => {
  const getPaymentLogs = () => {
    const list =
      details &&
      details.payment &&
      details.payment.paymentLog &&
      details.payment.paymentLog
        .map((entry, index) => {
          if (
            entry.channelType !== ChannelType.MERCHANT_PORTAL ||
            (entry.type !== TransactionTypes.CREATE &&
              entry.type !== TransactionTypes.MODIFY_CART)
          ) {
            return (
              <PaymentLogEntry
                key={index + entry.created}
                entry={entry}
                payment={details}
                index={index}
              />
            )
          }
          return null
        })
        .filter(entry => entry)

    return list && list.length ? (
      list
    ) : (
      <p style={{ textAlign: 'center' }}>
        {getText('transactions.transaction.history.empty')}
      </p>
    )
  }

  const getTransactionLogEntry = () => {
    const debitTransaction = {
      entryType: TransactionTypes.DEBIT,
      debitTransactionId: transaction?.transactionId,
      creditedAmountWithVat: transaction?.amount,
      creditDate: transaction?.date,
    }
    if (
      details.creditTransactions.findIndex(
        p => p.debitTransactionId === transaction?.transactionId,
      ) === -1
    ) {
      details.creditTransactions.unshift(debitTransaction)
    }
    const list =
      details &&
      details.creditTransactions &&
      details.creditTransactions.map((entry, index) => {
        return (
          <TransactionLogEntry
            key={index + entry.creditDate}
            entry={entry}
            index={index}
          />
        )
      })

    return <Container>{list}</Container>
  }

  return (
    <Page title={getText('transactions.transaction.history.title')}>
      {details.creditTransactions === undefined
        ? getPaymentLogs()
        : getTransactionLogEntry()}
    </Page>
  )
}

TransactionHistory.propTypes = {
  details: PropTypes.object,
  transaction: PropTypes.object,
}

TransactionHistory.defaultProps = {
  details: null,
  transaction: null,
}

export default TransactionHistory
